import * as React from "react";
function LgIcon() {
    return React.createElement("path", { d: "M4.00003 22V13H21V22H4.00003ZM5.5 20.5H19.5V14.5H5.5V20.5Z", fill: "currentColor" });
}
export default LgIcon;
//# sourceMappingURL=Lg.js.map